import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconViewLpComponent } from "./med-icon-view-lp.component";

@NgModule({
  declarations: [
    MedIconViewLpComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconViewLpComponent,
  ],
})
export class MedIconViewLpModule { }
